import { Card, Switch, Form, Input, Tag, Typography } from "antd";

const { Text } = Typography;

export default function EventsSection({ config, onChange }) {
  const events = config.eventsEnquiry;

  const update = (key, value) => {
    onChange({
      ...config,
      eventsEnquiry: {
        ...events,
        [key]: value
      }
    });
  };

  return (
    <Card bordered={false}>
      <Form layout="vertical">

        <Form.Item label="Enable Events / Party Enquiry">
          <Switch
            checked={events.enabled}
            onChange={(v) => update("enabled", v)}
          />
          <Text type="secondary">
            Capture leads for large groups and special events.
          </Text>
        </Form.Item>

        {events.enabled && (
          <Form.Item label="Event Types">
            {(events.eventTypes || []).map((type, i) => (
              <Tag
                key={i}
                closable
                onClose={() =>
                  update(
                    "eventTypes",
                    events.eventTypes.filter((_, idx) => idx !== i)
                  )
                }
              >
                {type}
              </Tag>
            ))}

            <Input
              placeholder="Type event type and press Enter"
              onPressEnter={(e) => {
                const value = e.target.value.trim();
                if (!value) return;
                update("eventTypes", [...events.eventTypes, value]);
                e.target.value = "";
              }}
            />
          </Form.Item>
        )}

      </Form>
    </Card>
  );
}
